// @ts-ignore
/* eslint-disable */
import request from "src/lib/axios";

/** 创建日租/时租订单 按 SKU.rentalPrice × 租赁时长计费；时长单位须与 SKU.rentalPriceUnit（day/hour）一致。支持幂等重入与一人一单。 POST /api/v1/app/order/rental/create */
export async function AppRentalControllerCreateV1(
  body: MyApi.CreateRentalOrderDto,
  options?: { [key: string]: any }
) {
  return request<MyApi.ApiResponseOutputCreateRentalOrderDto>(
    "/api/v1/app/order/rental/create",
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      data: body,
      ...(options || {}),
    }
  );
}
